function ClockIcon({ color }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Access time" clipPath="url(#clip0_244_333)">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.33325 8.00004C1.33325 4.32004 4.31325 1.33337 7.99325 1.33337C11.6799 1.33337 14.6666 4.32004 14.6666 8.00004C14.6666 11.68 11.6799 14.6667 7.99325 14.6667C4.31325 14.6667 1.33325 11.68 1.33325 8.00004ZM2.66659 8.00004C2.66659 10.9467 5.05325 13.3334 7.99992 13.3334C10.9466 13.3334 13.3333 10.9467 13.3333 8.00004C13.3333 5.05337 10.9466 2.66671 7.99992 2.66671C5.05325 2.66671 2.66659 5.05337 2.66659 8.00004ZM7.33325 4.66671H8.33325V8.16671L11.3333 9.94671L10.8333 10.7667L7.33325 8.66671V4.66671Z"
          fill={color ? color : '#464646'}
        />
      </g>
      <defs>
        <clipPath id="clip0_244_333">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ClockIcon;
